import { render, staticRenderFns } from "./ChatChannel.vue?vue&type=template&id=0a0f3d55&scoped=true&"
import script from "./ChatChannel.vue?vue&type=script&lang=js&"
export * from "./ChatChannel.vue?vue&type=script&lang=js&"
import style0 from "./ChatChannel.vue?vue&type=style&index=0&id=0a0f3d55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0f3d55",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!F:/Projects/Hugo/Ilead/FrontEnd/lbcleadership/Client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAvatar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VAvatar,VBtn,VCard,VCardActions,VCardText,VCardTitle,VCheckbox,VDialog,VDivider,VFlex,VIcon,VLayout,VListTile,VListTileAvatar,VSpacer,VTextarea,VToolbar,VToolbarTitle,VTooltip})
